export const COLOR_TOUPE = 'toupe';



// WEBPACK FOOTER //
// ./app/javascript/common/colors.js